var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPhoto(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 30,
    viewBox: "0 0 41 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1C1C1C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.132 12.418c2.211 0 4.003-1.845 4.003-4.12 0-2.276-1.792-4.121-4.003-4.121-2.211 0-4.004 1.845-4.004 4.12 0 2.276 1.793 4.12 4.004 4.12zm0-1.532c1.37 0 2.502-1.147 2.502-2.589 0-1.441-1.132-2.588-2.502-2.588-1.37 0-2.502 1.147-2.502 2.588 0 1.442 1.132 2.589 2.502 2.589z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75 3.149C.75 1.409 2.131 0 3.835 0h26.26c1.705 0 3.086 1.41 3.086 3.149v10.519c4.218.232 7.569 3.796 7.569 8.16 0 4.513-3.585 8.172-8.007 8.172-3.164 0-5.9-1.873-7.2-4.592H3.835c-1.704 0-3.085-1.41-3.085-3.149V3.15zm30.93 0v10.578a7.832 7.832 0 00-2.344.703l-3.67-3.489a1.889 1.889 0 00-2.536-.07l-8.124 6.921a.41.41 0 01-.501.025l-4.742-3.305a1.886 1.886 0 00-2.1-.043l-5.412 3.458V3.149c0-.893.71-1.617 1.584-1.617h26.26c.876 0 1.585.724 1.585 1.617zm-7.037 8.913l3.35 3.186a8.216 8.216 0 00-3.257 6.58c0 .707.088 1.393.253 2.047H3.835c-.875 0-1.584-.723-1.584-1.616v-2.562a.746.746 0 00.2-.09l6.009-3.839a.41.41 0 01.456.01l4.742 3.304a1.887 1.887 0 002.31-.113l8.124-6.922a.41.41 0 01.551.015zm8.1 14.533a.457.457 0 01-.452-.461v-3.845h-3.767a.457.457 0 01-.452-.461c0-.255.203-.462.452-.462h3.767v-3.844c0-.255.202-.461.452-.461s.452.206.452.461v3.845h3.767c.25 0 .452.206.452.46a.457.457 0 01-.452.462h-3.767v3.845a.457.457 0 01-.452.46z"
  }))));
}
export default SvgIconPhoto;